module.exports = __webpack_public_path__ + "img/newspaper-clipping.5ed4b7a5.svg";